import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PaymentFailed = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if we need to redirect to zhiborenqi.com
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');
    
    if (ref) {
      try {
        // Decode the ref parameter to recover the originating site.
        const source = atob(ref);
        if (source === 'zhiborenqi.com') {
          window.location.href = 'https://zhiborenqi.com/addfunds?status=failed&message=Payment%20failed';
          return;
        }
      } catch (e) {
        // Malformed ref — stay on this page and show the generic failure UI.
      }
    }
  }, [location]);

  return (
    <div className="payment-failed">
      <div className="failed-container">
        <div className="failed-icon">✕</div>
        <h1>Payment Failed</h1>
        <p>We're sorry, but your payment could not be processed.</p>
        <p className="sub-text">Please try again or contact our support team for assistance.</p>

        <div className="action-buttons">
          <button onClick={() => navigate(-1)} className="retry-button">
            Try Again
          </button>
          <a href="mailto:support@fbprotechwebexpert.com" className="support-button">
            Contact Support
          </a>
        </div>

        <div className="support-info">
          <h3>Need Help?</h3>
          <p>Our support team is available 24/7 to assist you.</p>
          <p>Email: support@fbprotechwebexpert.com</p>
          <p>Phone: +1 (555) 123-4567</p>
        </div>
      </div>

      <style>{`
        .payment-failed {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f8f9fa;
          padding: 20px;
        }
        .failed-container {
          background: white;
          padding: 40px;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          text-align: center;
          max-width: 600px;
          width: 100%;
        }
        .failed-icon {
          width: 80px;
          height: 80px;
          background: #dc3545;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 40px;
          margin: 0 auto 20px;
        }
        h1 {
          color: #dc3545;
          margin-bottom: 10px;
        }
        .sub-text {
          color: #6c757d;
          margin-top: 10px;
        }
        .action-buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          margin: 30px 0;
        }
        .retry-button, .support-button {
          padding: 12px 24px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 16px;
          transition: background 0.3s;
          display: inline-block;
          text-decoration: none;
        }
        .retry-button {
          background: #dc3545;
          color: white;
        }
        .support-button {
          background: #6c757d;
          color: white;
        }
        .retry-button:hover {
          background: #c82333;
        }
        .support-button:hover {
          background: #5a6268;
        }
        .support-info {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid #dee2e6;
        }
        .support-info h3 {
          color: #495057;
          margin-bottom: 10px;
        }
        .support-info p {
          color: #6c757d;
          margin: 5px 0;
        }
      `}</style>
    </div>
  );
};

export default PaymentFailed;
